import React, { useRef, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import useDemoTour from './useDemoTour';
import DemoWelcomeCard from './DemoWelcomeCard';
import DemoTourLauncher from './DemoTourLauncher';
import { runDemoTour } from './DemoTour';

/**
 * DemoTourRoot - single mount point for the demo walkthrough.
 * No-op for non-demo accounts.
 *
 * Render once inside the app shell (e.g. Layout.js). It reads `demo` from
 * redux via the `useDemoTour` hook so non-demo users see nothing at all.
 */
function DemoTourRoot({ history, location }) {
    const {
        isDemoUser,
        welcomeOpen,
        openWelcome,
        closeWelcome,
        markSkipped,
        markCompleted,
    } = useDemoTour(location.pathname);

    const tourRef = useRef(null);

    const startTour = useCallback(() => {
        closeWelcome();
        if (tourRef.current) {
            try { tourRef.current.stop(); } catch (e) { /* ignore */ }
        }
        tourRef.current = runDemoTour({
            history,
            onComplete: () => { tourRef.current = null; markCompleted(); },
            onSkip: () => { tourRef.current = null; markSkipped(); },
        });
    }, [closeWelcome, history, markCompleted, markSkipped]);

    if (!isDemoUser) return null;

    return (
        <>
            <DemoTourLauncher onClick={openWelcome} />
            <DemoWelcomeCard
                open={welcomeOpen}
                onStart={startTour}
                onDismiss={() => { closeWelcome(); markSkipped(); }}
            />
        </>
    );
}

export default withRouter(DemoTourRoot);
